import api from "../../../core/api";
import { InviteUser, InviteTemporaryUser, User, UserRole, ReinviteUser, PinRegenerate, EnableUser, DisableUser, ChangeUserRole } from "../models/userModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
}

const getAccountRequestConfig = () => {
  return { baseURL: (window as any).app.config.apiBaseUrl };
}

class CustomerUsersApi {
  getUsers(): Promise<User[]> {
    return api.get<User[]>(`/v1/users`, getRequestConfig()).then(x => x.data);
  }
  inviteUser(model: InviteUser): Promise<void> {
    return api.post<void>(`/v1/users/invite`, model, getRequestConfig()).then(() => undefined);
  }
  reinviteUser(model: ReinviteUser): Promise<void> {
    return api.post<void>(`/v1/users/reinvite`, model, getRequestConfig()).then(() => undefined);
  }

  inviteTemporaryUser(model: InviteTemporaryUser): Promise<void> {
    return api.post<void>(`/v1/users/invite/temporary`, model, getRequestConfig()).then(() => undefined);
  }

  pinRegenerate(model: PinRegenerate): Promise<void> {
    return api.post<void>(`/v1/users/pin-regenerate`, model, getRequestConfig()).then(() => undefined);
  }

  enableUser(model: EnableUser): Promise<void> {
    return api.post<void>(`/v1/users/enable`, model, getRequestConfig()).then(() => undefined);
  }

  disableUser(model: DisableUser): Promise<void> {
    return api.post<void>(`/v1/users/disable`, model, getRequestConfig()).then(() => undefined);
  }

  deleteUser(id: string): Promise<void> {
    return api.delete<void>(`/v1/users/${id}`, getRequestConfig()).then(() => undefined);
  }

  getRoles(): Promise<UserRole[]> {
    return api.get<UserRole[]>(`/v1/users/roles`, getAccountRequestConfig()).then(x => x.data);
  }

  changeUserRole(userId: string, model: ChangeUserRole): Promise<void> {
    return api.put<void>(`/v1/users/${userId}/role`, model, getAccountRequestConfig()).then(() => undefined);
  }
}

export default new CustomerUsersApi();